import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, brandPrimaryHover, navigation, tagBackgroundColor, titles } from '../../../styles/colors';
import { Fonts } from '../../../styles/styles';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	addDonationBtnPopover: {
		padding: 0,
	},
	importMenuContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		background: '#fff',
		border: `1px solid ${brandPrimary}`,
		borderRadius: 8,
		boxShadow: '0 1px 2px 0 #f9f9f9',
		overflow: 'hidden',
		minWidth: 200,
	},
	importMenuButton: {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		fontFamily: Fonts.lexend,
		fontSize: 14,
		padding: '10px 16px',
		textAlign: 'center',
		transition: 'color 0.2s, background-color 0.2s',
	},
	importMenuButtonPrimary: {
		color: brandPrimary,
		':hover': {
			background: '#EAF7FA',
			color: brandPrimaryHover,
		},
	},
	importMenuButtonSecondary: {
		color: navigation,
		fontSize: 13,
		':hover': {
			background: '#F5F5F5',
			color: titles,
		},
	},
	importMenuDivider: {
		background: '#E5E5E5',
		height: 1,
		width: '100%',
	},
	creationDateChipRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '4px 0 8px',
	},
	banner: {
		alignItems: 'center',
		background: tagBackgroundColor,
		display: 'flex',
		padding: '1rem 0.5rem',
		gap: 12,
	},
	bannerLink: {
		alignItems: 'center',
		color: colors.primary.main,
		display: 'inline-flex',
		fontWeight: 600,
		fontSize: 14,
		textDecoration: 'none',
	},

	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
		backgroundColor: 'transparent !important',
	},
	databoardContainer: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		backgroundColor: 'transparent !important',
	},
	infoHeaderContentBold: {
		marginTop: spacing.xs,
		marginBottom: 12,
		fontWeight: 600,
	},
	viewOnlyModeBannerContent: {
		display: 'flex',
		fontSize: 14,
		padding: '20px 20px 20px 40px',
		gap: 8,
	},
	viewOnlyModeBannerContainer: {
		justifyContent: 'space-between',
		display: 'flex',
		background: colors.tertiary.light,
		borderLeft: '3px solid #78DBFF',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: titles,
		alignItems: 'flex-start',
		marginBottom: spacing.md,
	},
	loadingRow: {
		height: 300,
	},
	inKindDescription: {
		color: navigation,
		fontSize: 12,
		fontWeight: 400,
		marginTop: 4,
	},
	donationRow: {
		':nth-child(n) > td': {
			verticalAlign: 'middle',
		},
	},
	rowWithDetails: {
		':nth-child(n) > td': {
			paddingBottom: 8,
		},
	},
	detailsRow: {
		borderTop: 'none',
	},
	detailsSpacerCell: {
		padding: '0 10px 0 10px',
		borderTop: 'none',
	},
	detailsCell: {
		padding: '0 10px 12px 10px',
		borderTop: 'none',
	},
});
